import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { Form } from 'react-bootstrap';

const ReactComponent = (Props) => {
  //{ handleChange, elementState, dateFormat, name, showTimeSelect }
  return (
    <>
      <DatePicker
        className={Props.className}
        name={Props.name}
        dateFormat={Props.dateFormat}
        showTimeSelect={Props.showTime.isEnabled}
        closeOnSelect={true}
        timeFormat={Props.showTime.format}
        timeIntervals={Props.showTime.interval}
        disabled={Props.elementState.disabled || false}
        selected={Props.elementState.value}
        onChange={(date) => {
          if (!date) return;
          if (Props.handleChange) Props.handleChange(date.getTime(), date);
        }}
        onChangeRaw={Props.handleChangeRaw ?? (() => {})}
        autoComplete={Props.autoComplete}
      />
      {Props.elementState.error && (
        <Form.Control.Feedback type="invalid" className="d-block">
          {Props.elementState.error}
        </Form.Control.Feedback>
      )}
    </>
  );
};

ReactComponent.propTypes = {
  handleChange: PropTypes.func.isRequired,
  elementState: PropTypes.shape({
    value: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    error: PropTypes.string,
  }).isRequired,
  dateFormat: PropTypes.array.isRequired,
  showTime: PropTypes.shape({
    isEnabled: PropTypes.bool.isRequired,
    format: PropTypes.string,
    interval: PropTypes.number,
  }),
  name: PropTypes.string,
  className: PropTypes.string,
};

ReactComponent.defaultProps = {
  name: 'awp_datepicker',
  dateFormat: ['yyyy-MM-dd HH:mm', 'yyyy-MM-dd', 'yyyyMMdd', 'yyyyMMddHHmm'],
  className: 'form-control',
  showTime: {
    isEnabled: true,
    format: 'HH:mm',
    interval: 60,
  },
};

export default ReactComponent;
